export enum WebSocketRoom {
  PUBLIC,
  PRIVATE
}
